import { DEFAULT_SCOPES } from "../components/auth/config";
import { Record } from 'react-admin';

export function arrayEquals(a: string[] | undefined, b: string[] | undefined): boolean {
  return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
}

export const checkIfDefaultScope = (array: string[] | undefined): boolean => {
  return arrayEquals(array, DEFAULT_SCOPES);
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: Array<string>;
}

interface Address {
  street_number?: string;
  route?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
}

export const useGoogleAddressParser = (address_components: google.maps.GeocoderAddressComponent[] | undefined) : { addressComponents: Address; error: string; } => {
  const addressComponents: Address = {};
  let error = ''

  if (!Array.isArray(address_components)) {
    error = 'Address Components is not an array';
  }

  if (Array.isArray(address_components) && !address_components.length) {
    error = 'Address Components is empty';
  }
  if(address_components) {
    for (const component of address_components) {

      if (isStreetNumber(component)) {
        addressComponents.street_number = component.long_name;
      }
  
      if (isStreetName(component)) {
        addressComponents.route = component.long_name;
      }
  
      if (isCity(component)) {
        addressComponents.city = component.long_name;
      }
  
      if (isCountry(component)) {
        addressComponents.country = component.long_name;
      }
  
      if (isState(component)) {
        addressComponents.state = component.short_name;
      }
  
      if (isPostalCode(component)) {
        addressComponents.zip = component.long_name;
      }
    }  
  }
  

  function isStreetNumber(component: AddressComponent): boolean {
    return component.types.includes('street_number');
  }

  function isStreetName(component: AddressComponent): boolean {
    return component.types.includes('route');
  }

  function isCity(component: AddressComponent): boolean {
    return component.types.includes('locality');
  }

  function isState(component: AddressComponent): boolean {
    return component.types.includes('administrative_area_level_1');
  }

  function isCountry(component: AddressComponent): boolean {
    return component.types.includes('country');
  }

  function isPostalCode(component: AddressComponent): boolean {
    return component.types.includes('postal_code');
  }  
  return { addressComponents, error};
}

export const mergeRecords = (record:Record, newRecord: Partial<Record>): void=> {
  const keys = Object.keys(newRecord);
  for (const key of keys) {
    record[key] = newRecord[key];
  }
}